import Helper from './Helper';

class TabsDropdown {
  constructor(config = {}) {
    const tabs = document.querySelectorAll('.lc-tabs__dropdown');
    const containers = document.querySelectorAll('.lc-tab-content');
    let containerActiveBefore;
    if(!!tabs){
      let index = 0;
      containers.forEach(cont => {
        if(index == 0){
          cont.style.display = 'block';
          cont.classList.add('active');
          containerActiveBefore = cont;
        }
        index++;
      });
    }
    tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        if(!tab.classList.contains('open')){
          tab.classList.add('open')
        } else{
          e.preventDefault();
        }
      });
      const items = tab.querySelectorAll('.lc-tabs__dropdown-item');
      let index = 0;
      let activeBefore;
      items.forEach(item => {
        item.dataset.index = index;
        if(index == 0){
          item.classList.add('active');
          activeBefore = item;
        }
        item.addEventListener('click', () => {
          if(tab.classList.contains('open')){
            if(!item.classList.contains('active')){
              activeBefore.classList.remove('active');
              item.classList.add('active');
              console.log(item.dataset.index);
              containerActiveBefore.classList.remove('active');
              setTimeout(() => {
                containerActiveBefore.style.display = 'none'
                containers[item.dataset.index].style.display = 'block';
                setTimeout(() => {
                  containers[item.dataset.index].classList.add('active');
                  containerActiveBefore = containers[item.dataset.index];
                }, 10);
              }, 300);


              console.log(containers[index]);
              activeBefore = item;
            }
            setTimeout(() => {
              tab.classList.remove('open');
            }, 100);
          }
        })
        index++;
      });
    })

  }



}

export default TabsDropdown;
